import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import * as icons from '@fortawesome/free-solid-svg-icons'
import api from './api';
import { useStore as zustand } from './zustand';
import { toast } from 'sonner';
import timezones from './timezones';
import moment from 'moment-timezone';
import { TimezonesKeys } from './timezones';
import randomTopics from './randomTopics';

export const randomString = (length = 8) => {
  const chars = "abcdefghijklmnopqrstuvwxyz0123456789";
  let result = "";
  for (let i = length; i > 0; --i)
    result += chars[Math.floor(Math.random() * chars.length)];
  return result;
};

export const checkValidUrl = (string: string) => {
  let url;
  try {
    url = new URL(string);
  } catch (_) {
    return false;
  }
  return url.protocol === "http:" || url.protocol === "https:";
};

export const GoToRoute = (route: string) => {
  window.location.href = route;
};

export const randomNumber = (min: number, max: number) => {
  return Math.floor(Math.random() * (max - min) + min);
}

export const multipleRandomNumbers = (min: number, max: number, count: number, canRepeat: boolean) => {
  let numbers: number[] = [];
  while (numbers.length < count) {
    let randomNumber = Math.floor(Math.random() * (max - min) + min);
    if (canRepeat) {
      numbers.push(randomNumber);
    } else {
      if (!numbers.includes(randomNumber)) {
        numbers.push(randomNumber);
      }
    }
  }
  return numbers;
}


const languages = [
  {
    id: 1,
    name: 'Português Brasil',
    code: 'PTBR',
  },
  {
    id: 2,
    name: 'English',
    code: 'EN',
  },
  {
    id: 3,
    name: 'Español',
    code: 'ES',
  },
  {
    id: 4,
    name: 'Français',
    code: 'FR',
  },
  {
    id: 5,
    name: 'Deutsch',
    code: 'DE',
  },
  {
    id: 6,
    name: 'Italiano',
    code: 'IT',
  }
]

const checkAuth = () => {
  const token = localStorage.getItem("token");
  if (token) {
    try {
      return api.post('/account/authcheck', { token }).then((response: any) => {
        if (response.data.status === 200) {
          localStorage.setItem("account", JSON.stringify(response.data.data));
          return true;
        }
        else {
          localStorage.removeItem('account');
          localStorage.removeItem('token');
          return false;
        }
      })
    }
    catch (err) {
      return false
    }
  }
  else {
    return false;
  }
}

export const stripeAllHtmlTags = (text: string) => {
  text = text?.replace(/<\/div>/g, '\n');
  text = text?.replace(/&nbsp;/g, ' ');
  text = text?.replace(/<br>/g, '\n');
  text = text?.replace(/<br\/>/g, '\n');
  text = text?.replace(/<br \/>/g, '\n');
  text = text?.replace(/<[^>]*>/g, '');
  return text;
}

export const formatAIText = (text: string) => {
  text = text?.replace(/<\/div>/g, '\n');
  text = text?.replace(/&nbsp;/g, ' ');
  text = text?.replace(/<br>/g, '\n');
  text = text?.replace(/<br\/>/g, '\n');
  text = text?.replace(/<br \/>/g, '\n');
  text = text?.replace(/\*/g, '');
  text = text?.replace(/\#/g, '');
  return text;
}

export const getAccount = () => {
  return JSON.parse(localStorage.getItem('account') || '{}');
}

export const canRequestAI = () => {
  const account = getAccount();
  if ((!account || account.accountType == 'free') && (account?.usedTokens >= account?.maxTokens)) return false;
  return true;
}

export const logout = () => {
  localStorage.removeItem('account');
  localStorage.removeItem('token');
  window.location.reload();
}

export const turnTimestampIntoTimer = (differenceBetweenTimestamps: number) => {
  /* format: YYYY/MM/DD HH:mm:ss */
  let time = new Date(differenceBetweenTimestamps);
  let hours = time.getUTCHours();
  let minutes = time.getUTCMinutes();
  let seconds = time.getUTCSeconds();
  let formattedTime = '';
  if (hours > 0) {
    formattedTime += `${hours.toString().padStart(2, '0')}:`;
  }
  formattedTime += `${minutes.toString().padStart(2, '0')}:`;
  if (seconds > 0) {
    formattedTime += `${seconds.toString().padStart(2, '0')}`;
  }
  else {
    formattedTime += '00';
  }
  return formattedTime;
}

export const getBrowserLanguage = () => {
  return (navigator.language || (navigator as any).userLanguage).toUpperCase().replace('-', '')
}

export const getTimezone = () => {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
}

export const formatDateWithTimezone = (date: string) => {
  const format = timezones[getTimezone() as TimezonesKeys] || 'MM/DD/YYYY HH:mm';
  return moment.tz(date, getTimezone()).format(format);
}

export const shuffleArray = (array: any[], forceNewPosition: boolean = false) => {
  for (let i = array.length - 1; i > 0; i--) {
    if (forceNewPosition) {
      if (i === 0) break;
      let j = Math.floor(Math.random() * i);
      [array[i], array[j]] = [array[j], array[i]];
      continue;
    }
    let j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
  return array;
}

let general = {
  checkAuth,
  randomString,
  randomNumber,
  multipleRandomNumbers,
  checkValidUrl,
  GoToRoute,
  FontAwesomeIcon,
  stripeAllHtmlTags,
  formatAIText,
  getAccount,
  logout,
  turnTimestampIntoTimer,
  getBrowserLanguage,
  getTimezone,
  formatDateWithTimezone,
  shuffleArray,
  canRequestAI,
  icons,
  api,
  zustand,
  toast,
  languages,
  timezones,
  randomTopics,
};

export default general;
